import React, { useState, useEffect } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
//import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API"; 
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";



const EditSource = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ source, setSource ] = useState([])
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};
  const Token = localStorage.getItem("authToken");
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    SourceInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    
  
    // Show confirmation alert before proceeding
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          setLoading(true); 
          const authToken = localStorage.getItem("authToken");
          const payload = {
            source_name: formData.source_name,
            source_desc: formData.source_desc,
            status: formData.status === "Active" ? 1 : 0,
          };
  
          // Add business partner ID based on user type
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          // Make API call to update the source
          const response = await axiosInstance.patch(`/source/update/${data.source_id}`, payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });
  
          // Handle successful response
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Source updated successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate(ROUTES_NAVIGATION.SOURCELIST); 
            });
          }
        } catch (error) {
          console.error('Error updating source:', error);
  
          const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
          Swal.fire({
            title: "Something went wrong",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false); 
        }
      },
    });
  
    if (!result.isConfirmed) {
      setLoading(false); 
    }
  };
  


  const fetchSourceEdit = async () => {
    try{
      const response = await axiosInstance.get(`/source/edit/${data.source_id}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
        },
    })
    const fetchedData = response.data.data
    const transformedData = {
      source_name:fetchedData.source_name,
      source_desc:fetchedData.source_desc,
      business_partner_id:fetchedData.business_partner_id,
      status: fetchedData.status === 1 ? "Active" : "Inactive",
    }
    setFormData(transformedData)
    setSource(fetchedData)
    console.log(formData, "HSNCODE DATA")
  
  }catch(error){
      console.log(error)
    }
  
  }
  
  useEffect(() => {
    fetchSourceEdit()
  },[])

  
  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      })
  
      const data = response.data.data.data
      console.log(data)
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  useEffect(() => {
    userTypedropdown()
  },[])

  const SourceInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: {
              required: true,
              pattern: /^[A-Za-z0-9 ]*$/,
              message: "Only alphabets and digits are allowed",
            },
          },
        ]
      : []),
    {
      name: "source_name",
      label: "Source Name",
      type: "text",
      required: true,
      validation: { required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
     },
      gridClass: "col-lg-4",
    },
    {
      name: "source_desc",
      label: "Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
  
  ];

  return (
    <>
     {loading ? (
        <Loader />
      ) : (
        <>
      <div className="backbutton mt-2 mb-2" onClick={() =>  navigate(ROUTES_NAVIGATION.SOURCELIST)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Edit Source</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Source Details
        </span>
        <DynamicForm
          formConfig={SourceInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
      )}
    </>
  );
};

export default EditSource;
